import React from 'react';

function Terms() {
  return (
    <p>
      <br />
      <strong>Agreement between User and RebuildBlackBusiness.com</strong>
      <br />
      <br /> Welcome to RebuildBlackBusiness.com. The RebuildBlackBusiness.com
      website (the "Site") is comprised of various web pages operated by Rebuild
      Black Business ("RBB"). RebuildBlackBusiness.com is offered to you
      conditioned on your acceptance without modification of the terms,
      conditions, and notices contained herein (the "Terms"). Your use of
      RebuildBlackBusiness.com constitutes your agreement to all such Terms.
      Please read these terms carefully, and keep a copy of them for your
      reference. <br />
      <br />
      RebuildBlackBusiness.com is a Non-Profit Site. <br />
      <br />
      RebuildBlackBusiness.com was birthed under the mission of restoring wealth
      to Black communities through economic empowerment and resource allocation.
      This website is a centralized hub for Black-owned businesses and serves as
      a platform to drive visibility and raise funds for Black-owned businesses
      across the nation. It will feature Black-owned businesses that have been
      impacted by recent social unrest. It will also offer the largest public
      directory of Black-owned businesses in the country. <br /> <br />
      <strong>Privacy</strong>
      <br /> <br /> Your use of RebuildBlackBusiness.com is subject to RBB's
      Privacy Policy. Please review our Privacy Policy, which also governs the
      Site and informs users of our data collection practices. <br />
      <br />
      <strong>Electronic Communications</strong>
      <br />
      <br />
      Visiting RebuildBlackBusiness.com or sending emails to RBB constitutes
      electronic communications. You consent to receive electronic
      communications and you agree that all agreements, notices, disclosures and
      other communications that we provide to you electronically, via email and
      on the Site, satisfy any legal requirement that such communications be in
      writing. <br />
      <br />
      <strong>Children Under Thirteen</strong> <br />
      <br />
      RBB does not knowingly collect, either online or offline, personal
      information from persons under the age of thirteen. If you are under 18,
      you may use RebuildBlackBusiness.com only with permission of a parent or
      guardian. <br />
      <br />
      <strong>Links to Third Party Sites/Third Party Services</strong> <br />
      <br />
      RebuildBlackBusiness.com may contain links to other websites ("Linked
      Sites"). The Linked Sites are not under the control of RBB and RBB is not
      responsible for the contents of any Linked Site, including without
      limitation any link contained in a Linked Site, or any changes or updates
      to a Linked Site. RBB is providing these links to you only as a
      convenience, and the inclusion of any link does not imply endorsement by
      RBB of the site or any association with its operators.
      <br />
      <br /> Certain services made available via RebuildBlackBusiness.com are
      delivered by third party sites and organizations. By using any product,
      service or functionality originating from the RebuildBlackBusiness.com
      domain, you hereby acknowledge and consent that RBB may share such
      information and data with any third party with whom RBB has a contractual
      relationship to provide the requested product, service or functionality on
      behalf of RebuildBlackBusiness.com users and customers. <br />
      <br />
      <strong>No Unlawful or Prohibited Use/Intellectual Property</strong>
      <br />
      <br />
      You are granted a non-exclusive, non-transferable, revocable license to
      access and use RebuildBlackBusiness.com strictly in accordance with these
      terms of use. As a condition of your use of the Site, you warrant to RBB
      that you will not use the Site for any purpose that is unlawful or
      prohibited by these Terms. You may not use the Site in any manner which
      could damage, disable, overburden, or impair the Site or interfere with
      any other party's use and enjoyment of the Site. You may not obtain or
      attempt to obtain any materials or information through any means not
      intentionally made available or provided for through the Site. <br />
      <br />
      All content included as part of the Service, such as text, graphics,
      logos, images, as well as the compilation thereof, and any software used
      on the Site, is the property of RBB or its suppliers and protected by
      copyright and other laws that protect intellectual property and
      proprietary rights. You agree to observe and abide by all copyright and
      other proprietary notices, legends or other restrictions contained in any
      such content and will not make any changes thereto. <br />
      <br /> You will not modify, publish, transmit, reverse engineer,
      participate in the transfer or sale, create derivative works, or in any
      way exploit any of the content, in whole or in part, found on the Site.
      RBB content is not for resale. Your use of the Site does not entitle you
      to make any unauthorized use of any protected content, and in particular
      you will not delete or alter any proprietary rights or attribution notices
      in any content. You will use protected content solely for your personal
      use, and will make no other use of the content without the express written
      permission of RBB and the copyright owner. You agree that you do not
      acquire any ownership rights in any protected content. We do not grant you
      any licenses, express or implied, to the intellectual property of RBB or
      our licensors except as expressly authorized by these Terms. <br />
      <br /> <strong>Use of Communication Services</strong>
      <br />
      <br /> The Site may contain bulletin board services, chat areas, news
      groups, forums, communities, personal web pages, calendars, and/or other
      message or communication facilities designed to enable you to communicate
      with the public at large or with a group (collectively, "Communication
      Services"). You agree to use the Communication Services only to post, send
      and receive messages and material that are proper and related to the
      particular Communication Service.
      <br />
      <br /> By way of example, and not as a limitation, you agree that when
      using a Communication Service, you will not: defame, abuse, harass, stalk,
      threaten or otherwise violate the legal rights (such as rights of privacy
      and publicity) of others; publish, post, upload, distribute or disseminate
      any inappropriate, profane, defamatory, infringing, obscene, indecent or
      unlawful topic, name, material or information; upload files that contain
      software or other material protected by intellectual property laws (or by
      rights of privacy of publicity) unless you own or control the rights
      thereto or have received all necessary consents; upload files that contain
      viruses, corrupted files, or any other similar software or programs that
      may damage the operation of another's computer; advertise or offer to sell
      or buy any goods or services for any business purpose, unless such
      Communication Service specifically allows such messages; conduct or
      forward surveys, contests, pyramid schemes or chain letters; download any
      file posted by another user of a Communication Service that you know, or
      reasonably should know, cannot be legally distributed in such manner;
      falsify or delete any author attributions, legal or other proper notices
      or proprietary designations or labels of the origin or source of software
      or other material contained in a file that is uploaded; restrict or
      inhibit any other user from using and enjoying the Communication Services;
      violate any code of conduct or other guidelines which may be applicable
      for any particular Communication Service; harvest or otherwise collect
      information about others, including e-mail addresses, without their
      consent; violate any applicable laws or regulations.
      <br />
      <br /> RBB has no obligation to monitor the Communication Services.
      However, RBB reserves the right to review materials posted to a
      Communication Service and to remove any materials in its sole discretion.
      RBB reserves the right to terminate your access to any or all of the
      Communication Services at any time without notice for any reason
      whatsoever.
      <br />
      <br /> RBB reserves the right at all times to disclose any information as
      necessary to satisfy any applicable law, regulation, legal process or
      governmental request, or to edit, refuse to post or to remove any
      information or materials, in whole or in part, in RBB's sole discretion.
      <br />
      <br />
      Always use caution when giving out any personally identifying information
      about yourself or your children in any Communication Service. RBB does not
      control or endorse the content, messages or information found in any
      Communication Service and, therefore, RBB specifically disclaims any
      liability with regard to the Communication Services and any actions
      resulting from your participation in any Communication Service. Managers
      and hosts are not authorized RBB spokespersons, and their views do not
      necessarily reflect those of RBB. <br />
      <br />
      Materials uploaded to a Communication Service may be subject to posted
      limitations on usage, reproduction and/or dissemination. You are
      responsible for adhering to such limitations if you upload the materials.
      <br />
      <br />
      <strong>
        Materials Provided to RebuildBlackBusiness.com or Posted on Any RBB Web
        Page
      </strong>
      <br />
      <br />
      RBB does not claim ownership of the materials you provide to
      RebuildBlackBusiness.com (including feedback and suggestions) or post,
      upload, input or submit to any RBB Site or our associated services
      (collectively "Submissions"). However, by posting, uploading, inputting,
      providing or submitting your Submission you are granting RBB, our
      affiliated companies and necessary sublicensees permission to use your
      Submission in connection with the operation of their Internet businesses
      including, without limitation, the rights to: copy, distribute, transmit,
      publicly display, publicly perform, reproduce, edit, translate and
      reformat your Submission; and to publish your name in connection with your
      Submission. <br />
      <br />
      No compensation will be paid with respect to the use of your Submission,
      as provided herein. RBB is under no obligation to post or use any
      Submission you may provide and may remove any Submission at any time in
      RBB's sole discretion. <br />
      <br />
      By posting, uploading, inputting, providing or submitting your Submission
      you warrant and represent that you own or otherwise control all of the
      rights to your Submission as described in this section including, without
      limitation, all the rights necessary for you to provide, post, upload,
      input or submit the Submissions. <br />
      <br />
      <strong>International Users</strong> <br />
      <br />
      The Service is controlled, operated and administered by RBB from our
      offices within the USA. If you access the Service from a location outside
      the USA, you are responsible for compliance with all local laws. You agree
      that you will not use the RBB Content accessed through
      RebuildBlackBusiness.com in any country or in any manner prohibited by any
      applicable laws, restrictions or regulations.
      <br />
      <br /> <strong>Indemnification</strong> <br />
      <br />
      You agree to indemnify, defend and hold harmless RBB, its officers,
      directors, employees, agents and third parties, for any losses, costs,
      liabilities and expenses (including reasonable attorney's fees) relating
      to or arising out of your use of or inability to use the Site or services,
      any user postings made by you, your violation of any terms of this
      Agreement or your violation of any rights of a third party, or your
      violation of any applicable laws, rules or regulations. RBB reserves the
      right, at its own cost, to assume the exclusive defense and control of any
      matter otherwise subject to indemnification by you, in which event you
      will fully cooperate with RBB in asserting any available defenses.
      <br />
      <br />
      <strong>Arbitration</strong> <br />
      <br />
      In the event the parties are not able to resolve any dispute between them
      arising out of or concerning these Terms and Conditions, or any provisions
      hereof, whether in contract, tort, or otherwise at law or in equity for
      damages or any other relief, then such dispute shall be resolved only by
      final and binding arbitration pursuant to the Federal Arbitration Act,
      conducted by a single neutral arbitrator and administered by the American
      Arbitration Association, or a similar arbitration service selected by the
      parties, in a location mutually agreed upon by the parties. The
      arbitrator's award shall be final, and judgment may be entered upon it in
      any court having jurisdiction. In the event that any legal or equitable
      action, proceeding or arbitration arises out of or concerns these Terms
      and Conditions, the prevailing party shall be entitled to recover its
      costs and reasonable attorney's fees. The parties agree to arbitrate all
      disputes and claims in regards to these Terms and Conditions or any
      disputes arising as a result of these Terms and Conditions, whether
      directly or indirectly, including Tort claims that are a result of these
      Terms and Conditions. The parties agree that the Federal Arbitration Act
      governs the interpretation and enforcement of this provision. The entire
      dispute, including the scope and enforceability of this arbitration
      provision shall be determined by the Arbitrator. This arbitration
      provision shall survive the termination of these Terms and Conditions.
      <br />
      <br />
      <strong>Class Action Waiver</strong>
      <br />
      <br />
      Any arbitration under these Terms and Conditions will take place on an
      individual basis; class arbitrations and class/representative/collective
      actions are not permitted. THE PARTIES AGREE THAT A PARTY MAY BRING CLAIMS
      AGAINST THE OTHER ONLY IN EACH'S INDIVIDUAL CAPACITY, AND NOT AS A
      PLAINTIFF OR CLASS MEMBER IN ANY PUTATIVE CLASS, COLLECTIVE AND/ OR
      REPRESENTATIVE PROCEEDING, SUCH AS IN THE FORM OF A PRIVATE ATTORNEY
      GENERAL ACTION AGAINST THE OTHER. Further, unless both you and RBB agree
      otherwise, the arbitrator may not consolidate more than one person's
      claims, and may not otherwise preside over any form of a representative or
      class proceeding. <br />
      <br />
      <strong>Liability Disclaimer</strong>
      <br />
      <br /> THE INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES INCLUDED IN OR
      AVAILABLE THROUGH THE SITE MAY INCLUDE INACCURACIES OR TYPOGRAPHICAL
      ERRORS. CHANGES ARE PERIODICALLY ADDED TO THE INFORMATION HEREIN.
      <br />
      <br />
      REBUILD BLACK BUSINESS AND/OR ITS SUPPLIERS MAY MAKE IMPROVEMENTS AND/OR
      CHANGES IN THE SITE AT ANY TIME. REBUILD BLACK BUSINESS AND/OR ITS
      SUPPLIERS MAKE NO REPRESENTATIONS ABOUT THE SUITABILITY, RELIABILITY,
      AVAILABILITY, TIMELINESS, AND ACCURACY OF THE INFORMATION, SOFTWARE,
      PRODUCTS, SERVICES AND RELATED GRAPHICS CONTAINED ON THE SITE FOR ANY
      PURPOSE. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, ALL SUCH
      INFORMATION, SOFTWARE, PRODUCTS, SERVICES AND RELATED GRAPHICS ARE
      PROVIDED "AS IS" WITHOUT WARRANTY OR CONDITION OF ANY KIND. REBUILD BLACK
      BUSINESS AND/OR ITS SUPPLIERS HEREBY DISCLAIM ALL WARRANTIES AND
      CONDITIONS WITH REGARD TO THIS INFORMATION, SOFTWARE, PRODUCTS, SERVICES
      AND RELATED GRAPHICS, INCLUDING ALL IMPLIED WARRANTIES OR CONDITIONS OF
      MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE AND
      NON-INFRINGEMENT. <br />
      <br />
      TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL
      REBUILD BLACK BUSINESS AND/OR ITS SUPPLIERS BE LIABLE FOR ANY DIRECT,
      INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, CONSEQUENTIAL DAMAGES OR ANY
      DAMAGES WHATSOEVER INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF USE,
      DATA OR PROFITS, ARISING OUT OF OR IN ANY WAY CONNECTED WITH THE USE OR
      PERFORMANCE OF THE SITE, WITH THE DELAY OR INABILITY TO USE THE SITE OR
      RELATED SERVICES, THE PROVISION OF OR FAILURE TO PROVIDE SERVICES, OR FOR
      ANY INFORMATION, SOFTWARE, PRODUCTS, SERVICES AND RELATED GRAPHICS
      OBTAINED THROUGH THE SITE, OR OTHERWISE ARISING OUT OF THE USE OF THE
      SITE, WHETHER BASED ON CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY OR
      OTHERWISE, EVEN IF REBUILD BLACK BUSINESS OR ANY OF ITS SUPPLIERS HAS BEEN
      ADVISED OF THE POSSIBILITY OF DAMAGES. BECAUSE SOME STATES/JURISDICTIONS
      DO NOT ALLOW THE EXCLUSION OR LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR
      INCIDENTAL DAMAGES, THE ABOVE LIMITATION MAY NOT APPLY TO YOU. IF YOU ARE
      DISSATISFIED WITH ANY PORTION OF THE SITE, OR WITH ANY OF THESE TERMS OF
      USE, YOUR SOLE AND EXCLUSIVE REMEDY IS TO DISCONTINUE USING THE SITE.
      <br />
      <br />
      <strong>Termination/Access Restriction</strong>
      <br />
      <br /> RBB reserves the right, in its sole discretion, to terminate your
      access to the Site and the related services or any portion thereof at any
      time, without notice. To the maximum extent permitted by law, this
      agreement is governed by the laws of the State of Georgia and you hereby
      consent to the exclusive jurisdiction and venue of courts in Georgia in
      all disputes arising out of or relating to the use of the Site. Use of the
      Site is unauthorized in any jurisdiction that does not give effect to all
      provisions of these Terms, including, without limitation, this section.
      <br />
      <br />
      You agree that no joint venture, partnership, employment, or agency
      relationship exists between you and RBB as a result of this agreement or
      use of the Site. RBB's performance of this agreement is subject to
      existing laws and legal process, and nothing contained in this agreement
      is in derogation of RBB's right to comply with governmental, court and law
      enforcement requests or requirements relating to your use of the Site or
      information provided to or gathered by RBB with respect to such use. If
      any part of this agreement is determined to be invalid or unenforceable
      pursuant to applicable law including, but not limited to, the warranty
      disclaimers and liability limitations set forth above, then the invalid or
      unenforceable provision will be deemed superseded by a valid, enforceable
      provision that most closely matches the intent of the original provision
      and the remainder of the agreement shall continue in effect. <br />
      <br />
      Unless otherwise specified herein, this agreement constitutes the entire
      agreement between the user and RBB with respect to the Site and it
      supersedes all prior or contemporaneous communications and proposals,
      whether electronic, oral or written, between the user and RBB with respect
      to the Site. A printed version of this agreement and of any notice given
      in electronic form shall be admissible in judicial or administrative
      proceedings based upon or relating to this agreement to the same extent
      and subject to the same conditions as other business documents and records
      originally generated and maintained in printed form. It is the express
      wish to the parties that this agreement and all related documents be
      written in English. <br />
      <br />
      <strong>Changes to Terms</strong> <br />
      <br />
      RBB reserves the right, in its sole discretion, to change the Terms under
      which RebuildBlackBusiness.com is offered. The most current version of the
      Terms will supersede all previous versions. RBB encourages you to
      periodically review the Terms to stay informed of our updates. <br />
      <br />
      <strong>Contact Us</strong> <br />
      <br />
      RBB welcomes your questions or comments regarding the Terms:
      <br />
      <br />
      Rebuild Black Business <br />
      P.O. Box 13881 Atlanta, Georgia 30324 <br />
      Email Address: social@rebuildblackbusiness.com <br />
      _________________ <br />
      Effective as of June 10, 2020
      <br />
      <br />
    </p>
  );
}

export default Terms;
